import type {ComputationResult} from './../computation-result';
import type {Computation} from './../computation';
import type {Grouping} from './../../grouping/grouping';
import type {PValueAdjustmentMethod} from './../../stats/pvalue-adjustment-method';
import type {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.univariate.PairwiseMoodTest
 */
export interface PairwiseMoodTest extends Computation._UnivariateComputation {
    adjustmentMethod: PValueAdjustmentMethod;
    grouping: Grouping;

    // PolyJson type
    type: 'pairwise_mood_test';
}

export namespace PairwiseMoodTest {
    export const type = 'pairwise_mood_test';
}

/** @deprecated Use Computation.isPairwiseMoodTest() */ export function isPairwiseMoodTest(toTest: Computation): toTest is PairwiseMoodTest { return PairwiseMoodTest.type === toTest['type']; }

export namespace PairwiseMoodTest {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.PairwiseMoodTest$PairwiseMoodTestResult
     */
    export interface PairwiseMoodTestResult extends _AvailableResult {
        pvalues: number[];
        statistics: number[];

        // PolyJson type
        type: 'pairwise_mood_test';
    }

    export namespace PairwiseMoodTestResult {
        export const type = 'pairwise_mood_test';
    }

    /** @deprecated Use ComputationResult.isPairwiseMoodTestResult() */ export function isPairwiseMoodTestResult(toTest: ComputationResult): toTest is PairwiseMoodTestResult { return PairwiseMoodTestResult.type === toTest['type']; }
}